/* eslint-disable import/prefer-default-export */
import * as moment from 'moment';
import * as Constants from '@/constants';
import utilityFunctions from './functions';

export function isWithinOneYear(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const oneYearPrior = new Date(moment().subtract(365, 'days').format('YYYY-MM-DD')).getTime();
    return slDate >= oneYearPrior;
  }
  return true;
}

export function isBetweenStartAndEndDate(value, parentVm) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value && parentVm && parentVm.serviceStartDate && parentVm.serviceEndDate) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projStart = new Date(moment(parentVm.serviceStartDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projEnd = new Date(moment(parentVm.serviceEndDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    return slDate >= projStart && slDate <= projEnd;
  }
  return true;
}

export function isNotFutureDate(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const now = new Date().getTime();
    return now >= slDate;
  }
  return true;
}

export function areMinutesGreaterThanZero(value) {
  if (value) {
    return Number(value) > 0;
  }
  return true;
}

export function isValidGroupSize(value) {
  if (value) {
    return Number(value) > 0 && Number.isInteger(Number(value));
  }
  return true;
}

export function isValidLength(value) {
  if (value) {
    return Number(value) <= 999999999;
  }
  return true;
}

export function isProviderLocationRequired(value, parentVm) {
  if (!value) return parentVm.deliveryMode !== Constants.TELEPRACTICE;
  return true;
}

export function isValidMinutes(value, parentVm) {
  if (value) {
    const sessionTime =
      parentVm.sessionTime ? utilityFunctions.convertTimeToMinutes(parentVm.sessionTime, true) : null;
    const maxMinutes = 1440 - sessionTime;
    // make sure that the number is an integer
    return Number.isInteger(Number(value)) && (Number(value) <= 1440) && (maxMinutes >= value);
  }
  return true;
}

export function isSessionTimeEndGreaterThanSessionTime(value, parentVm) {
  if (value && parentVm && parentVm.sessionTime) {
    const startMil = utilityFunctions.calculateMilitaryTime(parentVm.sessionTime, true);
    const startTime = utilityFunctions.convertTimeToMinutes(startMil, true);
    const endMil = utilityFunctions.calculateMilitaryTime(value, false);
    if (startTime) {
      return utilityFunctions.convertTimeToMinutes(endMil, false) > startTime;
    }
  }
  return true;
}

// validation that service length (session Minutes) is equal to sum of procedures.
export function isTotalMedicaidMinutesValid(value, parentVm) {
  if (parentVm && parentVm.serviceInformation.serviceDelivered && parentVm.serviceInformation.sessionMinutes) {
    const serviceDelivered = parentVm.serviceInformation.serviceDelivered;
    const absentType = parentVm.serviceInformation.absentType;
    if (serviceDelivered && !Constants.IS_ABSENT(absentType)) {
      const sessionMinutes = parseInt(parentVm.serviceInformation.sessionMinutes, 10);
      return sessionMinutes === value;
    }
  }
  return true;
}

// validation to make sure reimbursable minutes are 0 when serviceDelivered is not
// reimbursable (Consultation, parent-training, observation)
export function isTotalReimbursableMinutesValidForNonReimbursable(value, parentVm) {
  if (parentVm && parentVm.serviceInformation.serviceDelivered) {
    const serviceDelivered = parentVm.serviceInformation.serviceDelivered;
    if (!Constants.IS_SD_REIMBURSABLE(serviceDelivered)) {
      return value === 0;
    }
  }
  return true;
}

export function isTotalReimbursableMinutesValid(value, parentVm) {
  if (value && parentVm && parentVm.serviceInformation.sessionMinutes) {
    const sessionMinutes = parseInt(parentVm.serviceInformation.sessionMinutes, 10);
    if (sessionMinutes) {
      return sessionMinutes >= value;
    }
  }
  return true;
}

export function isValidSessionValueLength(value) {
  if (value === undefined || value === null) return true;
  const invalidItems = value.filter((item) => {
    return item.name.length > 1000;
  })
  return invalidItems.length === 0;
}

export function isValidStudentBehaviorLength(value) {
  if (value === undefined || value === null) return true;
  return value.length > 300;
}



// WEBPACK FOOTER //
// ./src/utils/validations.js